export const OperatorValue = {
  CONTAINS: 'CONTAINS',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  IN: 'IN',
  INCLUDES: 'INCLUDES',
  IS_ANY_OF: 'IS_ANY_OF',
  IS_NULL: 'IS_NULL',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  MATCH_EXACTLY: 'MATCH_EXACTLY',
} as const;
export type OperatorValue = typeof OperatorValue[keyof typeof OperatorValue];
